<template>
    <ac-modal :title="'Payment Details'" ref="modal">
        <template v-if="widgetReady">
            <div class="row">
                <div v-for="fm in familyMembers" class="col-sm-12 col-md-6 col-lg-6">
                    <p><strong>Family Member:</strong> {{ fm.patient }}</p>
                    <p><strong>Provider Selection:</strong> {{ fm.planEffectiveDate | shortDate }}</p>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "PayrollDeductionsDetailsModal",
        components: {AcModal},
        data() {
            return {
                widgetReady: false,
                familyMembers: []
            };
        },
        methods: {
            async showModal({companyId, paymentRecordId, consumerId}) {
                this.widgetReady = false;
                this.familyMembers = await api.getDataWithTwoIds('PaymentReport', companyId, 'GetPayrollDeductionsDetails', paymentRecordId);
                this.familyMembers = this.familyMembers.filter((el) => el.consumerId == consumerId);
                this.widgetReady = true;
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }
</style>